import {
  createPressure,
  pressureToHectopascal,
  pressureToMmhg,
  pressureToBar,
  pressureToPascal,
  pressureToMillibar,
} from 'measure-fns';

export const convertPressure = (rawPressure: number, unit: string | undefined): string => {
  const resolvedUnit = unit ?? 'hPa';
  const pressure = createPressure(rawPressure);
  switch (resolvedUnit.toLowerCase()) {
    case 'hpa':
      return `${pressureToHectopascal(pressure, { round: true })} hPa`;
    case 'mmhg':
      return `${pressureToMmhg(pressure, { round: true })} mmHg`;
    case 'bar':
      return `${pressureToBar(pressure, { round: true })} bar`;
    case 'pa':
      return `${pressureToPascal(pressure, { round: true })} Pa`;
    case 'mbar':
      return `${pressureToMillibar(pressure, { round: true })} mbar`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
